import { connect } from 'react-redux';

import GoogleTagManagerActivationView from './GoogleTagManagerActivationView.jsx';
import { activateAccount } from 'src/legacy/redux/actions/integrations/googleTagManager.jsx';
import {trackAdoptionMetricsForPluginConnectedEvent} from "src/legacy/redux/actions/adoption";

const mapStateToProps = (state, ownProps) => {
  return {
    activating: state.legacyRootReducer.settings.integrations.googleTagManager.activation.activating,
    error: state.legacyRootReducer.settings.integrations.googleTagManager.activation.error
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    activateAccount : (configuration) => {
        return dispatch(activateAccount(configuration))
    },
    trackAdoptionMetricsForPluginConnectedEvent: (partnerName) => {
      return dispatch(trackAdoptionMetricsForPluginConnectedEvent(partnerName))
    }
  }
}

const GoogleTagManagerActivationPage = connect (
    mapStateToProps,
    mapDispatchToProps
)(GoogleTagManagerActivationView);

export default GoogleTagManagerActivationPage;
